// Component: VendorsCard
// Author: Neha
import VendorsCardNPM from '@rotaryintl/myrotary-vendors-card';
import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import i18n from 'i18next';
 
const VendorsCard = (props) => {
  var VendorsData = {
    title: props?.fields?.Title?.value || '',
    location: props?.fields?.Location?.value || '',
    phone: props?.fields?.Phone?.value || '',
    fax: props?.fields?.Fax?.value || '',
    website: props?.fields?.Website?.value?.href || '',
    email: props?.fields?.Email?.value || '',
    merchandise: props?.fields?.Merchandise?.value || '',
    phoneLabel: props?.fields?.PhoneLabel || i18n.t('VendorsCardPhone',{DefaultValue:'Phone'}),
    faxLabel: props.fields?.FaxLabel || i18n.t('VendorsCardFax',{DefaultValue:'Fax'}),
    websiteLabel: props.fields?.WebsiteLabel || i18n.t('VendorsCardWebsite',{DefaultValue:'Website'}),
    emailLabel: props.fields?.EmailLabel || i18n.t('VendorsCardEmail',{DefaultValue:'Email'}),
    merchandiseLabel: props.fields?.MerchandiseLabel || i18n.t('VendorsCardMerchandise',{DefaultValue:'Merchandise'}),
  };
  return (
    <VendorsCardNPM
      title={VendorsData.title}
      location={VendorsData.location}
      phone={VendorsData.phone}
      fax={VendorsData.fax}
      website={VendorsData.website}
      email={VendorsData.email}
      merchandise={VendorsData.merchandise}
      phoneLabel={VendorsData.phoneLabel}
      faxLabel={VendorsData.faxLabel}
      websiteLabel={VendorsData.websiteLabel}
      emailLabel={VendorsData.emailLabel}
      merchandiseLabel={VendorsData.merchandiseLabel}
    ></VendorsCardNPM>
  );
};
 
export default withSitecoreContext()(VendorsCard);
